import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
    selector: 'app-wetter-carousel',
    imports: [
    CarouselComponent
],
    templateUrl: './wetter-carousel.component.html',
    styleUrls: ['./wetter-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WetterCarouselComponent {
  public tiles: CarouselTile[] = [
    // {
    //   img: {
    //     src: 'assets/img/steg-weathercheck.jpg',
    //     objectPosition: '50% 50%',
    //     // width: 5400,
    //     // height: 3710,
    //     alt: 'Wetter-Check',
    //     // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
    //     sizes: ['90vw'],
    //     priority: true,
    //     loading: 'eager',
    //   }
    // },
    {
      img: {
        src: 'assets/img/steg-auftakt24.jpg',
        objectPosition: '50% 50%',
        // width: 5400,
        // height: 3710,
        alt: 'Steg des YSTM bei Wind im Frühjahr',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
        sizes: ['90vw'],
        priority: true,
        loading: 'eager',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/h-jolle3.jpg',
    //     objectPosition: '50% 70%',
    //     // width: 5400,
    //     // height: 3710,
    //     alt: 'Spaß mit der H-Holle auf dem Wasser',
    //     // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/weather-energie.jpg',
        objectPosition: '50% 50%',
        // width: 5400,
        // height: 3710,
        alt: 'MoBo-Fahrt bei Starkwind',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/dart3.jpg',
    //     width: 5400,
    //     height: 5177,
    //     alt: 'Katamaran-Regatta YSTM',
    //     breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    // {
    //   img: {
    //     src: 'assets/img/dn5.jpg',
    //     objectPosition: '50% 60%',
    //     // width: 5400,
    //     // height: 3771,
    //     alt: 'Eissegeln bei Wind & Schnee',
    //     // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    // {
    //   img: {
    //     src: 'assets/img/md/pboot3.webp',
    //     width: 821,
    //     height: 572,
    //     alt: 'P-Boot-Regatta im YSTM',
    //     srcset: [
    //       'assets/img/xs/pboot3.webp 688w',
    //       'assets/img/sm/pboot3.webp 821w',
    //       'assets/img/md/pboot3.webp 572w',
    //       'assets/img/lg/pboot3.webp 821w',
    //       'assets/img/xl/pboot3.webp 821w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/steg5.jpg',
        objectPosition: '50% 60%',
        // width: 5400,
        // height: 4050,
        alt: 'Nachmittag im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/heinstude2.jpg',
        objectPosition: '50% 60%',
        // width: 374,
        // height: 281,
        alt: 'YSTM-Club-Boot Hein-Stude',
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/grund1.jpg',
        objectPosition: '50% 60%',
        // width: 374,
        // height: 249,
        alt: 'An Land im YSTM',
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/sunset3.jpg',
        // width: 3648,
        // height: 2056,
        alt: 'An Land im YSTM',
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/polar-lights.jpg',
        // width: 3648,
        // height: 2056,
        alt: 'Polar-Lichter im YSTM',
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];

  // depreciated version without image CDN
  // public tiles: YsCarouselTile[] = [
  //   {
  //     img: {
  //       src: 'assets/img/md/pboot3.webp',
  //       width: 821,
  //       height: 572,
  //       alt: 'P-Boot-Regatta im YSTM',
  //       srcset: [
  //         'assets/img/xs/pboot3.webp 688w',
  //         'assets/img/sm/pboot3.webp 821w',
  //         'assets/img/md/pboot3.webp 572w',
  //         'assets/img/lg/pboot3.webp 821w',
  //         'assets/img/xl/pboot3.webp 821w',
  //       ],
  //       sizes: ['90vw'],
  //       priority: true,
  //     }
  //   },
  //   {
  //     img: {
  //       src: 'assets/img/md/heinstude2.webp',
  //       width: 374,
  //       height: 281,
  //       alt: 'YSTM-Club-Boot Hein-Stude',
  //       srcset: [
  //         'assets/img/xs/heinstude2.webp 230w',
  //         'assets/img/sm/heinstude2.webp 304w',
  //         'assets/img/md/heinstude2.webp 3740w',
  //         'assets/img/lg/heinstude2.webp 454w',
  //         'assets/img/xl/heinstude2.webp 774w',
  //       ],
  //       sizes: ['90vw'],
  //       priority: true,
  //     }
  //   },
  //   {
  //     img: {
  //       src: 'assets/img/md/grund1.webp',
  //       width: 374,
  //       height: 249,
  //       alt: 'An Land im YSTM',
  //       srcset: [
  //         'assets/img/xs/grund1.webp 230w',
  //         'assets/img/sm/grund1.webp 304w',
  //         'assets/img/md/grund1.webp 374w',
  //         'assets/img/lg/grund1.webp 454w',
  //         'assets/img/xl/grund1.webp 774w',
  //       ],
  //       sizes: ['90vw'],
  //       priority: true,
  //     }
  //   },
  // ];
}
